import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
export const usePurchaseFlow = t0 => {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mode: t2,
    type
  } = t1;
  const mode = t2 === undefined ? "full" : t2;
  let t3;
  if ($[2] !== mode || $[3] !== type) {
    t3 = (items, options) => {
      FlowActions.startFlow({
        type: "checkout",
        items,
        mode,
        slippage: options?.slippage,
        purchaseType: type,
        isClaim: options?.isClaim
      });
    };
    $[2] = mode;
    $[3] = type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};